import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {
    FieldArray,
    FormArray,
    FormBuilder, Validators,
} from "react-reactive-form";
import AddIcon from '@material-ui/icons/Add';
import {renderCommentFormGroup} from "../../services/utils-upload-generic";

class UploadGenericHighlightComponent extends Component {
    keyCount = 0;
    formArray: FormArray ;
    questionsDefaultValue = {
        ['file']: null,

    };

    constructor(props) {
        super(props);
        this.state = {
            name: '',
        };
    }

    createUniqueKey = () => {
        return this.keyCount++;
    };

    addComment(control,required) {
        let formGroup;
        if(required === true) {
            formGroup = FormBuilder.group({
                ['receipt_file']: [null, [Validators.required]],
            });
        } else{
            formGroup = FormBuilder.group({
                ['receipt_file']: [null],
            });
        }
        formGroup.meta = {
            key: this.createUniqueKey()
        };
        control.push(formGroup);
    }


    renderFormQuestions() {
        return (
            <FieldArray
                name={'receipt_file'}
                render={((control) => {
                    this.formArray = control;
                    return (
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12}>
                                {renderCommentFormGroup(control,this.props.title,this.props.label)}
                            </Grid>
                        </Grid>
                    )
                })}
            />
        )
    }

    render() {
        let displayAddQuestion = true;
        if (this.formArray) {
            if (this.formArray.controls.length > 0) {
                displayAddQuestion = false;
            }
        }

        return (
            <Grid container style={{marginTop: '15px'}}>
                {!displayAddQuestion && <Grid item xs={12}>
                </Grid>}
                <Grid item xs={10}>
                    {this.renderFormQuestions()}

                </Grid>
                <Grid item xs={2}>
                    <p>{this.state.name}</p>

                </Grid>
                <div>
                    <Button style={{color: '#00005a', fontSize: '14px', boxShadow: 'none', fontWeight: '700',textTransform: 'none', backgroundColor: 'transparent'}}
                            data-cy="add-first-question" startIcon={<AddIcon/>} onClick={() => {
                        this.addComment(this.formArray,this.props.required);
                        this.formArray.updateValueAndValidity();
                    }}>
                        <AddIcon/> Ajouter
                    </Button>
                </div>
            </Grid>
        );
    }

}

export default UploadGenericHighlightComponent;





// WEBPACK FOOTER //
// ./src/views/Components/upload-generic-receipt.component.jsx